import { Blue, Gray, White } from '@constants/color';
import { css } from '@emotion/react';

export const rootContainer = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  height: '1080px'
});
export const mainContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '120px',
  padding: '64px',
  width: '1280px'
});
export const mainTopContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '40px'
});
export const mainContentContainer = css({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '120px',
  padding: '80px 0 0 120px'
});

export const rightContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '40px'
});

export const title = css({
  color: White.White10,
  fontSize: '48px',
  fontWeight: 700,
  whiteSpace: 'pre-line'
});
export const subtitle = css({
  color: White.White10,
  fontSize: '40px',
  fontWeight: 700
});
export const information = css({
  color: Blue.Blue40,
  fontSize: '32px',
  fontWeight: 700
});
export const content = css({
  color: Gray.Gray50,
  fontSize: '28px',
  fontWeight: 500,
  whiteSpace: 'pre-line'
});

export const qr = css({
  width: 440,
  height: 440,
  border: '10px solid #fff'
});
